jQuery(document).ready(function() {
  var videoHeroSection = jQuery('.video-parent-section');
  var getWindowWidth = jQuery(window).width();

  if(videoHeroSection.length === 0) {
    return;
  }

  function calculateProportionalVideoDimensions(el,video, width) {
    return video.addEventListener('loadedmetadata', function() {
      const videoWidth = video.videoWidth;
      const videoHeight = video.videoHeight;
      const videoRatio = videoWidth / videoHeight;
      $(el).css({
        height: width / videoRatio
      })
    });
  }
  
  videoHeroSection.each(function(i,el) {
    const video = $(el).find('video').get(0);
    const videoPermalink = $(el).data('external-link');
    calculateProportionalVideoDimensions(el,video,getWindowWidth)
    window.addEventListener('resize', function() {
      calculateProportionalVideoDimensions(el,video,window.innerWidth)
    });

    if(videoPermalink){
      $(el).css({
        cursor: 'pointer'
      })
      $(el).on('click', function(){
         window.location.href = window.location.origin + videoPermalink;
      });
    }
  });
});
